import { useMutation } from 'Data/Api'
import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data, reExecuteQuery) {
  let onReOrderQuestions = useOnReOrderQuestions(props)

  return async function onSubmit({ value, originalValue, args, change }) {
    switch (args.type) {
      case 'reFetch': {
        reExecuteQuery({ requestPolicy: 'network-only' })
        return
      }

      case 're-order': {
        return onReOrderQuestions({ value, originalValue, args, change })
      }

      default:
        return
    }
  }
}

function useOnReOrderQuestions(props) {
  let [, executeMutation] = useMutation(mutation)
  return async function onSubmit({ value, originalValue, args, change }) {
    let differences = findOrderCorrections(
      value
        .filter(item => !args.deleted.includes(item.id))
        .map(question => ({
          id: question.id,
          order: question.order,
        }))
    )
    await executeMutation({
      updates: differences.map(difference => ({
        where: {
          id: { _eq: difference.id },
        },
        _set: { order: difference.order },
      })),
    })
  }
}

function findOrderCorrections(items) {
  let sorted = [...items].sort((a, b) => a.order - b.order)

  let updates = []
  let expectedOrder = 1

  for (let i = 0; i < sorted.length; i++) {
    let item = sorted[i]
    if (item.order !== expectedOrder) {
      updates.push({ id: item.id, order: expectedOrder })
    }
    expectedOrder++
  }

  return updates
}
